var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoeFormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.259,
    height: 13.703,
    viewBox: "0 0 34.259 13.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.4,9.713V8H33.689L31.976,9.713H24.268L22.555,8H20.842L10.565,14.852H5.426A3.426,3.426,0,0,0,2,18.278V21.7H15.7l5.139-1.713h3.426V21.7H35.4V18.278A10.392,10.392,0,0,0,36.259,14,10.392,10.392,0,0,0,35.4,9.713Z",
    transform: "translate(-2 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoeFormal);
export default __webpack_public_path__ + "static/media/shoe-formal.7b5a78b347ae8a5d6ef7568acfe2a9ae.svg";
export { ForwardRef as ReactComponent };